import { useState, useCallback } from 'react';

const LS_KEY = 'gamedrop_claimed_v1';

function loadClaimed() {
  try {
    return new Set(JSON.parse(localStorage.getItem(LS_KEY) || '[]'));
  } catch {
    return new Set();
  }
}

function saveClaimed(set) {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify([...set]));
  } catch { /* storage full — ignore */ }
}

export function useClaimed() {
  const [claimed, setClaimed] = useState(loadClaimed);

  const toggleClaimed = useCallback((id) => {
    setClaimed(prev => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      saveClaimed(next);
      return next;
    });
  }, []);

  const isClaimed = useCallback((id) => claimed.has(id), [claimed]);

  return { isClaimed, toggleClaimed };
}
